import Model from './Model';

export default class Maillead extends Model {
  resource() {
    return 'maillead';
  }
}
